import React, { useEffect } from 'react';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { MailIcon } from '@zola/zola-ui/src/components/SvgIcons/Mail';
import { MailIcon as MailIconV3 } from '@zola/zola-ui/src/components/SvgIconsV3/Mail';
import { trackNavigationClicked } from '@zola/tracking-contracts/src/tracking';
import { fetchInquiryList, fetchUnreadCounts } from 'actions/InquiryActions';
import { connect, useSelector } from 'react-redux';
import { getUnreadCount } from 'selectors/InquirySelectors';
import type { AppDispatch } from '../../../reducers';

const Messages: React.FC<{
  userId: string;
  handleFetchUnreadCounts: () => void;
  handlefetchInquiryList: () => void;
  isPostAuthNav3Enabled?: boolean;
  navigationLevelPosition?: number;
}> = ({
  userId,
  handleFetchUnreadCounts,
  handlefetchInquiryList,
  isPostAuthNav3Enabled,
  navigationLevelPosition,
}) => {
  const unreadTotal = useSelector(getUnreadCount);

  useEffect(() => {
    if (userId) {
      handleFetchUnreadCounts();
      handlefetchInquiryList();
    }
  }, [handleFetchUnreadCounts, handlefetchInquiryList, userId]);

  const svgDimensions = {
    title: 'Messages',
    height: 40,
    width: 40,
  };

  const handleClick = () => {
    trackNavigationClicked({
      business_category: 'UNATTRIBUTED',
      business_unit: 'MARKETPLACE',
      navigation_level_1: 'INQUIRIES',
      navigation_level_1_position: navigationLevelPosition || 1,
      navigation_type: 'UTILITY',
    });
  };

  const renderMessages = unreadTotal ? <span className="badge">{unreadTotal}</span> : null;

  return (
    <LinkV2
      className="icon-link nav-util__bell"
      aria-label="Your Messages"
      href="/wedding-vendors/inquiries/active"
      onClick={handleClick}
    >
      {renderMessages}
      {isPostAuthNav3Enabled ? (
        <MailIconV3 title="Messages" height={20} width={20} />
      ) : (
        <MailIcon className="nav-util__icon" {...svgDimensions} />
      )}
    </LinkV2>
  );
};
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  handleFetchUnreadCounts: () => dispatch(fetchUnreadCounts()).catch(() => null),
  handlefetchInquiryList: () => dispatch(fetchInquiryList()).catch(() => null),
});

export default connect(null, mapDispatchToProps)(Messages);
